import { render, staticRenderFns } from "./FeedbackSession.vue?vue&type=template&id=35166910&scoped=true&"
import script from "./FeedbackSession.vue?vue&type=script&lang=js&"
export * from "./FeedbackSession.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackSession.vue?vue&type=style&index=0&id=35166910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35166910",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VBtn,VContainer,VForm,VTextarea})
